import { useCallback } from "react";
import { endpoints } from "../api/ApiEndpoints";
import {api} from "../api/ApiService";

export interface IMediaFilesService {
    getConvertedVideoSasUrl(fileId: number): Promise<string>;
}

export default function useMediaFilesService(): IMediaFilesService {
    const getConvertedVideoSasUrl = useCallback(async (fileId:number) => {
        const endpoint = endpoints.get("get_video_conversion_sas");
        endpoint.routeParams = [fileId];
        return await api.get(endpoint);
    }, [api])

    return {
        getConvertedVideoSasUrl
    }
}